<template>
  <div class="register">
    <div class="form">
      <div class="form-item">
        <input
          type="number"
          v-model="mobile"
          placeholder="请输入手机号"
          maxlength="11"
        />
        <div
          class="suffix"
          :disabled="send_verify_code_btn_disabled"
          @click="sendVerifyCode"
        >
          {{ btn_text }}
        </div>
      </div>
      <div class="form-item">
        <input
          type="number"
          v-model="verifyCode"
          placeholder="请输入验证码"
          maxlength="6"
        />
      </div>
      <van-button
        type="info"
        @click="submit"
        :disabled="commit_btn_enable"
        :loading="commit_btn_loading"
        loading-text="登录中..."
        >登录</van-button
      >
    </div>
    <div class="clear" @click="clear"></div>
  </div>
</template>

<script>
let timer = null
export default {
  data() {
    return {
      btn_text: '发送验证码',
      mobile: '',
      verifyCode: '',
      commit_btn_enable: true,
      send_verify_code_btn_disabled: true,
      commit_btn_loading: false,
    }
  },
  methods: {
    sendVerifyCode() {
      if (this.send_verify_code_btn_disabled) {
        return false
      }
      if (!/^1[3456789]{1}\d{9}$/.test(this.mobile)) {
        this.$toast({
          text: '请输入正确的手机号',
          type: 'warn',
        })
        return
      }
      this.send_verify_code_btn_disabled = true
      this.axios
        .get(`/student-consumer/api/textMessage/sendVerificationCodeMessage`, {
          params: {
            phone: this.mobile,
            schoolId: localStorage.getItem('schoolId'),
          },
        })
        .then((res) => {
          if (res.code === 200) {
            this.times = 60
            timer = setInterval(() => {
              this.times--
              if (this.times < 0) {
                clearInterval(timer)
                this.btn_text = '获取验证码'
                this.send_verify_code_btn_disabled = false
                return
              }
              this.btn_text = `${this.times}s后重新获取验证码`
            }, 1000)
          } else {
            this.send_verify_code_btn_disabled = false
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
          this.send_verify_code_btn_disabled = false
        })
    },
    submit() {
      if (!/^1[3456789]{1}\d{9}$/.test(this.mobile)) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (!this.verifyCode) {
        this.$toast('请输入验证码')
        return
      }
      this.commit_btn_loading = true
      this.axios
        .post('auth/api/bindLogin', {
          captcha: this.verifyCode,
          code: localStorage.getItem('code'),
          phone: this.mobile,
          schoolId:
            Object.keys(this.$store.state.inviteSubData).length > 0
              ? this.$store.state.inviteSubData.schoolId
              : this.$store.state.schoolId,
          appId: this.$store.state.appId,
        })
        .then((res) => {
          if (res.code == 200) {
            res.data &&
              localStorage.setItem('userInfo', JSON.stringify(res.data))
            res.data &&
              res.data.token &&
              localStorage.setItem('token', res.data.token)
            localStorage.setItem('id', res.data.id)
            this.$store.commit('setUserId', res.data.id)
            // this.$router.go(-1)
            if (localStorage.getItem('path')) {
              this.$router.push({
                path: '/inviteAddPeer',
                replace: true,
              })
              return
            }
            if (localStorage.getItem('subpath')) {
              this.$router.push({
                path: '/subscribe',
                replace: true,
              })
              return
            }
            if (res.data.personType === 13) {
              this.$router.push({
                path: '/approval',
                replace: true,
              })
            } else if (res.data.personType === 2) {
              this.$router.push({
                path: '/visitor',
                replace: true,
              })
            } else {
              this.$router.push({
                path: '/Attendance',
                replace: true,
              })
              // this.$router.push({ path: '/notice-setting', replace: true })
            }
          } else {
            this.$toast(`${res.msg}，请重试`)
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally((_) => {
          this.commit_btn_loading = false
        })
    },
    clear() {
      // sessionStorage.clear()
      localStorage.clear()
    },
  },
  watch: {
    mobile(newVal, oldVal) {
      if (/^1[3456789]{1}\d{9}$/.test(newVal) && !timer) {
        this.send_verify_code_btn_disabled = false
      } else {
        this.send_verify_code_btn_disabled = true
      }
    },
    verifyCode(newVal, oldval) {
      if (newVal) {
        this.commit_btn_enable = false
      } else {
        this.commit_btn_enable = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.clear {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 200px;
  height: 100px;
  background: #fff;
}

.register {
  text-align: center;
  padding: 1.5em;
  height: 100%;
  background: #fff;
  height: 100vh;

  .form {
    margin-top: 1.8em;

    .form-item {
      position: relative;
      height: 2.6em;
      border-bottom: 1px solid rgba(233, 226, 226, 0.952);
      margin-bottom: 1em;
      display: flex;
      align-items: center;
      justify-content: space-around;

      input {
        font-size: 1.1rem;
        height: 100%;
        width: 100%;
        padding: 0 0.8em;
        border: none;
        flex: 1;
      }

      .suffix {
        font-size: 0.8rem;
        color: #1989fa;

        &[disabled] {
          color: #ccc;
        }
      }
    }

    button {
      height: 2.6em;
      line-height: 2.6em;
      border-radius: 2px;
      width: 100%;
      margin-top: 1em;
      font-size: 1.1rem;
    }
  }
}
</style>
